import { render, staticRenderFns } from "./Analize.vue?vue&type=template&id=66875e92&scoped=true"
import script from "./Analize.vue?vue&type=script&lang=js"
export * from "./Analize.vue?vue&type=script&lang=js"
import style0 from "./Analize.vue?vue&type=style&index=0&id=66875e92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66875e92",
  null
  
)

export default component.exports